<template>
  <table border="1" class="grouplist">
    <tbody>
    <tr class="title">
      <th scope="col" class="no">&nbsp;</th>
      <th scope="col" class="tenpo-name">{{ $t("freeFood.storeName") }}</th>
      <th scope="col" class="area">{{ $t("freeFood.area") }}</th>
      <th scope="col" class="course">{{ $t("freeFood.course") }}</th>
      <th scope="col" class="holiday">{{ $t("freeFood.holiday") }}</th>
      <th scope="col" class="hours">{{ $t("freeFood.hours") }}</th>
    </tr>
    <tr v-for="item in content.groupList" :key="item.groupListId" class="pre-wrap">
      <td class="nbr">{{ item.groupListId }}</td>
      <td>{{ item.groupList1 }}</td>
      <td class="ari">{{ item.groupList2 }}</td>
      <td>{{ item.groupList3 }}</td>
      <td>{{ item.groupList4 }}</td>
      <td>{{ item.groupList5 }}</td>

    </tr>
    <tr class="black">
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import text from "@/assets/txt/free_food.json";

var textDate = text;
export default {
  data() {
    return {
      content: textDate,
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/organisms/freeFood/freeFoodContent.scss";
@import "@/assets/css/molecules/freeFood/groupList.scss";
</style>
